import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin } from 'lucide-react';
import { useApp } from '../../context/AppContext';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_9e7963b6-8d0a-418d-8246-af7a5b4f8387/artifacts/h6dgewwm_image.png';

export const Footer = () => {
  const { t } = useApp();

  const quickLinks = [
    { path: '/products', label: t('nav.products') },
    { path: '/grading', label: t('nav.grading') },
    { path: '/refurbishment', label: t('nav.refurbishment') },
    { path: '/export', label: t('nav.export') },
    { path: '/about', label: t('nav.about') },
    { path: '/faqs', label: t('nav.faqs') },
  ];

  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="main-footer" className="bg-[#0A0A0A] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <img src={LOGO_URL} alt="LUXOR TEK" className="h-12" />
            </Link>
            <p className="text-white/60 text-sm leading-relaxed">
              {t('footer.tagline')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm">
              {t('footer.quickLinks')}
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-white/60 hover:text-[#00D4FF] text-sm transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm">
              {t('footer.contact')}
            </h4>
            <ul className="space-y-4">
              <li>
                <a
                  href="mailto:sales@luxortek.com"
                  className="flex items-center gap-3 text-white/60 hover:text-[#00D4FF] text-sm transition-colors"
                  data-testid="footer-email"
                >
                  <Mail className="w-4 h-4" />
                  sales@luxortek.com
                </a>
              </li>
              <li className="flex items-start gap-3 text-white/60 text-sm">
                <MapPin className="w-4 h-4 mt-0.5" />
                <span>Miami Export Hub<br />Florida, USA</span>
              </li>
            </ul>
          </div>

          {/* Newsletter / CTA */}
          <div>
            <h4 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm">
              {t('footer.followUs')}
            </h4>
            <p className="text-white/60 text-sm mb-4">
              Contact us for wholesale pricing and inventory lists.
            </p>
            <Link
              to="/contact"
              className="btn-primary inline-block"
              data-testid="footer-contact-btn"
            >
              {t('nav.contact')}
            </Link>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-sm">
            © {currentYear} LUXOR TEK. {t('footer.rights')}.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/admin/login" className="text-white/40 hover:text-white/60 text-sm transition-colors">
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
